import {removeExpedientResponsible} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../../../expedient-keys";

export function removeExpedientResponsibleMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.removeExpedientResponsible,
    mutationFn: (memberId: string) => removeExpedientResponsible(id, memberId),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: expedientKeys.detail(id)}),
        client.invalidateQueries({queryKey: expedientKeys.lists()}),
      ]);
    },
  });
}
